module.exports = __webpack_public_path__ + "img/map.2c857d44.svg";